import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './Portal.module.scss';

type PortalProps = {
  children: ReactNode;
  backdrop?: boolean;
  onClose?: () => void;
  isFullView?: boolean;
  position?: { top?: number; right?: number; left?: number; bottom?: number };
};

const Portal: React.FC<PortalProps> = ({ children, onClose, isFullView = false, position, backdrop = false }) => {
  const portalRoot = document.getElementById('portal-root');

  if (!portalRoot) {
    const div = document.createElement('div');
    div.id = 'portal-root';
    document.body.appendChild(div);
  }

  return ReactDOM.createPortal(
    <div
      className={classNames(styles.root, {
        [styles.portalBackdrop]: isFullView,
        [styles.portalBackdrop]: backdrop,
      })}
      style={position}
      onClick={onClose}
      onKeyDown={onClose}
      role="presentation">
      {children}
    </div>,
    document.getElementById('portal-root')!,
  );
};

export default Portal;
